/* import __COLOCATED_TEMPLATE__ from './ticket-created.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();